import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { getMyCustomerProfile } from '../../api/customerProfile';
import { roleHome } from '../../lib/roleHome';

export const CustomerRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  const { data: profile, isLoading: profileLoading } = useQuery({
    queryKey: ['my-customer-profile'],
    queryFn: getMyCustomerProfile,
    enabled: user?.role === 'CUSTOMER',
  });

  if (isLoading || (user?.role === 'CUSTOMER' && profileLoading)) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}><CircularProgress /></Box>;
  }

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'CUSTOMER') return <Navigate to={roleHome(user.role)} replace />;
  if (!profile?.isProfileComplete && location.pathname !== '/profile-complete') {
    return <Navigate to="/profile-complete" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};
